// Literal class names (not `col-span-${n}`) so Tailwind's scanner keeps every one in the build.
export const DETAIL_SPAN_CLASS: Readonly<Record<number, string>> = {
    1: 'col-span-1',
    2: 'col-span-2',
    3: 'col-span-3',
    4: 'col-span-4',
    5: 'col-span-5',
    6: 'col-span-6',
    7: 'col-span-7',
    8: 'col-span-8',
    9: 'col-span-9',
    10: 'col-span-10',
    11: 'col-span-11',
    12: 'col-span-12'
};

export const DETAIL_LABEL_CLASS =
    'text-[12px] font-semibold text-gray-500 flex items-center gap-1.5';
